import type { PrivilegeMap } from "./privilege.data";

const privilegeMap = {
    customerONTInfo: {
        name: "Info ONT Pelanggan",
        privileges: [{ name: "access", desc: "Lihat", on: ["associate"] }],
    },
    hotspotVoucher: {
        name: "Voucher Hotspot",
        privileges: [
            { name: "access", desc: "Lihat, Download & Print", on: ["reseller"] },
            { name: "create", desc: "Generate", on: ["reseller"] },
            { name: "update", desc: "Disconnect", on: ["reseller"] },
        ],
    },
} as const satisfies PrivilegeMap;

type Feature = keyof typeof privilegeMap;
type Methods<T extends Feature> = (typeof privilegeMap)[T]["privileges"][number]["name"];
type MethodMap<T> = T extends Feature ? `${T}.${Methods<T>}` : never;
export type APIPrivilegeNames = MethodMap<Feature>;

export const apiPrivilegeMap = {
    customerONTInfo: privilegeMap.customerONTInfo,
} as const satisfies PrivilegeMap;

export const apiPinResellerPrivilegeMap: PrivilegeMap = {
    hotspotVoucher: privilegeMap.hotspotVoucher,
} satisfies Partial<Record<Feature, PrivilegeMap[string]>>;
